import {
  deleteResource,
  getList,
  setIsFetching,
  addOneNotification,
} from 'src/core/redux/actions';
import { Product, DesignType } from 'src/models';
import { state as stateConstants } from 'src/constants';

import messages from './messages';

export const deleteProducts = (
  ids,
  isViewAllActive,
  fetchProducsPayload,
  setSelectedProductsIds
) => async (dispatch) => {
  const payload = { workspaceIds: ids };
  const model = isViewAllActive ? DesignType : Product;

  dispatch(setIsFetching(model)());

  const response = await dispatch(deleteResource(Product)(payload));

  const hasError = response?.notFound?.length;
  const hasSuccess = response?.deleted?.length;

  if (hasError) {
    const message = hasSuccess ? messages.partialErrorDeleteProducts : messages.errorDeleteProducts;

    dispatch(addOneNotification({ type: 'error', message }));
  }

  if (hasSuccess) {
    const message = hasError ?
      messages.partialSuccessDeleteProducts :
      messages.successDeleteProducts;

    dispatch(addOneNotification({ type: 'success', message }));
  }

  if (isViewAllActive) {
    setSelectedProductsIds([]);
    await dispatch(getList(DesignType)());
  } else {
    setSelectedProductsIds([]);
    await dispatch(getList(Product)(fetchProducsPayload));

    await dispatch(getList(Product, stateConstants.IDENTIFIER_TYPE_TOTAL_LIST)({
      ...fetchProducsPayload,
      pagination: null
    }));
  }
};
